<div class="login-screen">
  <div class="login-modal">
    <span class="login-title" style="position: absolute;
      top: -105px;
      color: white;
      width: 310px;
      line-height: unset;
      left: 90px;
      font-weight: bold;
      font-size: 40px;
      text-align: center;">ГАРАНЦИОННА СИСТЕМА</span>
    <span class="login-title" style="color:#02477e;">Забравена парола</span>
    <span class="error" *ngIf="error">{{ errorMessage }}</span>
    <span class="success" *ngIf="success">Имейлът е изпратен успешно!</span>
    <div class="login-row">
      <span class="label">Имейл</span>
      <input type="email" [(ngModel)]="email" (keyup.enter)="requestPasswordReset()" (change)="error = false; success = false" placeholder="" />
    </div>
    <div class="login-btn" (click)="requestPasswordReset()">Изпрати</div>
    <div class="back-to-login" (click)="goToLogin()">Обратно към вход</div>
    <img src="../assets/tempex-white-logo.svg" style="width: 300px;
      position: absolute;
      bottom: -100px;
      left: 95px;" />
  </div>
</div>
